import React, {useEffect} from 'react';
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useRoomSocket} from '../../../hooks/useRoomSocket';
import {usePresentationParams} from '../../../hooks/usePresentationParams';
import RoomLoaderWrapper from './RoomLoaderWrapper';
import RoomEndCountdown from './parts/RoomEndCountdown';
import {roomSelector} from '../../../store/selectors/roomRunFile.selectors';
import {RoomStatus} from '../../../incase-domain/rooms/room.player';

function RoomWrapper(): JSX.Element {
    useRoomSocket();

    const navigate = useNavigate();
    const location = useLocation();
    const {roomId} = usePresentationParams();

    const room = useSelector(roomSelector);

    useEffect(() => {
        if (roomId === room.roomId) {
            const lobbyLink = `/room/lobby${location.search}`;
            const playingLink = `/room/play${location.search}`;

            if ([RoomStatus.IDLE, RoomStatus.LOBBY].includes(room.roomStatus)) {
                navigate(lobbyLink);
            } else if (room.roomStatus === RoomStatus.PLAYING) {
                navigate(playingLink);
            } else {
                navigate(lobbyLink);
            }
        }
    }, [roomId, room.roomStatus, location.search, navigate, room.roomId]);

    if (!roomId) {
        return <Navigate replace to="/" />;
    }

    return (
        <RoomLoaderWrapper>
            <RoomEndCountdown />
            <Outlet />
        </RoomLoaderWrapper>
    );
}

export default RoomWrapper;
